import React from "react";

/**
 * Microsoft Clarity - async, non-blocking.
 * Waits for window `load`, then schedules on idle so it does not compete with LCP/TTI.
 */
function loadClarity() {
  if (typeof window === "undefined" || window.clarity) return;

  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", "xu23hzg1st");
}

function scheduleClarity() {
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(() => loadClarity(), { timeout: 3000 });
  } else {
    window.setTimeout(() => loadClarity(), 0);
  }
}

export const onClientEntry = () => {
  if (process.env.NODE_ENV !== "production") return;

  if (document.readyState === "complete") {
    scheduleClarity();
  } else {
    window.addEventListener("load", () => scheduleClarity(), { once: true });
  }
};

export const wrapPageElement = ({ element }) => element;
